import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { userAuthoredPlaylists } from '../../redux/selectors/playlists'
import { createNewPlaylistEntry } from '../../redux/actions/playlistEntries'
import { getPlaylistEntries } from '../../redux/selectors/playlistEntries'
import { currentUser } from '../../redux/selectors/user'
import CreateNewPlaylistModal from '../playlist/modals/CreateNewPlaylistModal'
import AddToPlaylistModal from '../playlist/modals/AddToPlaylistModal'
import {
  featurePlanEntry,
  unfeaturePlanEntry
} from '../../redux/actions/planEntries'
import { isPlanEntryFeatured } from '../../redux/selectors/planEntries'
import Favoritable from './Favoritable'
import NestedHoverMenuPlusIcon from './NestedMenuPlusIcon'

class FavoritePlusButton extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      playlistSelectModalOpen: false,
      newPlaylistModalOpen: false
    }
  }

  render () {
    return (
      <Favoritable planEntry={this.props.planEntry}>
        {({ toggleFavorite, isFavorited }) => {
          let menuOptions = [
            {
              text: 'Add To Playlist',
              children: [
                {
                  text: 'New Playlist',
                  underlined: true,
                  handleClick: () => {
                    this.setState({ newPlaylistModalOpen: true })
                  }
                }
              ].concat(
                this.props.userPlaylists.map(playlist => {
                  return {
                    text: playlist.title,
                    included: this.props.playlistEntries
                      .filter({
                        playlist: playlist.uuid,
                        planEntry: this.props.planEntry.id
                      })
                      .exists(),
                    handleClick: () => {
                      this.props.createNewPlaylistEntry(
                        playlist.uuid,
                        this.props.planEntry.getId()
                      )
                    }
                  }
                })
              )
            },
            {
              text: isFavorited ? 'Remove From My Practice' : 'Save To Classes',
              handleClick: toggleFavorite
            }
          ]

          if (this.props.currentUser && this.props.currentUser.admin) {
            menuOptions = menuOptions.concat([
              {
                text: this.props.entryIsFeatured ? 'Unfeature' : 'Feature',
                handleClick: () => {
                  let action
                  if (this.props.planEntry.featured) {
                    this.props.planEntry.unfeature()
                    action = 'unfeature'
                  } else {
                    this.props.planEntry.feature()
                    action = 'feature'
                  }
                  this.props.updateFeaturedFlagInTree(action)
                }
              }
            ])
          }

          return (
            <div onClick={this.props.handleClick}>
              <CreateNewPlaylistModal
                active={this.state.newPlaylistModalOpen}
                onHide={() => {
                  this.setState({ newPlaylistModalOpen: false })
                }}
                planEntryId={this.props.planEntry.id}
              />
              <AddToPlaylistModal
                planEntry={this.props.planEntry}
                playlists={this.props.userPlaylists}
                playlistEntries={this.props.playlistEntries}
                show={this.state.playlistSelectModalOpen}
                onHide={() => {
                  this.setState({ playlistSelectModalOpen: false })
                }}
                onAdd={playlist => {
                  this.props.createNewPlaylistEntry(
                    playlist.uuid,
                    this.props.planEntry.getId()
                  )
                  this.setState({ playlistSelectModalOpen: false })
                }}
              />
              <NestedHoverMenuPlusIcon
                menuOptions={menuOptions}
                active={isFavorited}
              />
            </div>
          )
        }}
      </Favoritable>
    )
  }
}

FavoritePlusButton.propTypes = {
  active: PropTypes.bool,
  createNewPlaylistEntry: PropTypes.func,
  handleClick: PropTypes.func,
  planEntry: PropTypes.object,
  playlistEntries: PropTypes.object,
  userPlaylists: PropTypes.array,
  currentUser: PropTypes.object,
  updateFeaturedFlagInTree: PropTypes.func,
  entryIsFeatured: PropTypes.bool
}

const mapStateToProps = (state, ownProps) => {
  return {
    userPlaylists: userAuthoredPlaylists(state),
    playlistEntries: getPlaylistEntries(state),
    currentUser: currentUser(state),
    entryIsFeatured: isPlanEntryFeatured(state, ownProps.planEntry.id)
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    createNewPlaylistEntry: (playlistUUID, planEntryId) => {
      dispatch(createNewPlaylistEntry(playlistUUID, planEntryId))
    },
    updateFeaturedFlagInTree: action => {
      if (action === 'feature') {
        dispatch(featurePlanEntry(ownProps.planEntry.id))
      } else {
        dispatch(unfeaturePlanEntry(ownProps.planEntry.id))
      }
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FavoritePlusButton)
